/* eslint @typescript-eslint/no-require-imports: 0*/
import React, { Component } from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';
import { observer } from 'mobx-react';
import { hot } from 'react-hot-loader/root';
import classlist from 'utils/classlist';
import security from 'stores/security';
import WebWidget from 'components/forms/WebWidget';
import withSSR, { SSRProps } from 'utils/withSSR';
import Header from './Header';
import Footer from './Footer';
import RenderRoutes from './RenderRoutes';

if (typeof window !== 'undefined') {
    require('js2css3/css3-animation');
}

@observer
class App extends Component<RouteComponentProps & SSRProps<{}>> {
    componentDidMount() {
        // init中监听us-portal传进的token
        security.init();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location !== this.props.location) {
            window.scrollTo(0, 0);
        }
    }

    render() {
        const {
            location: { pathname },
            ui
        } = this.props;
        const isEmail = pathname.includes('email');

        return (
            <div
                className={classlist(`site-page-${ui.pid}`, 'us-portal-root', {
                    'site-clear-mode': ui.clearMode,
                    'site-within-app': ui.isTiger
                })}>
                {!ui.isTiger && <Route component={Header} />}
                <section
                    className={classlist(
                        `site-container`,
                        { 'app-site-container': ui.isTiger },
                        { 'email-site-container': isEmail }
                    )}>
                    <RenderRoutes />
                </section>
                {!ui.isTiger && <Footer />}
                {!ui.isTiger && <WebWidget isMarscoAccount={security.isMarscoAccount} isLogin={security.isLogin} />}
            </div>
        );
    }
}

export default hot(withSSR(App));
